import { ethers } from 'ethers'
import { getSupportNetwork } from '../../constants'

const namespaced = true

const ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'market',
        type: 'address',
      },
      {
        internalType: 'uint32',
        name: 'duration',
        type: 'uint32',
      },
    ],
    name: 'getPtToAssetRate',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
]

const CONFIG = {
  42161: [
    {
      pendlePtOracle: '0x9a9fa8338dd5e5b2188006f1cd2ef26d921650c2',
      expire: Date.UTC(2024, 8, 26),
      assets: [
        {
          // PT_weETH_26SEP2024
          underly: '0xb8b0a120f6a68dd06209619f62429fb1a8e92fec',
          market: '0xf9f9779d8ff604732eba9ad345e6a27ef5c2a9d6',
          duration: 1800,
        },
        {
          // PT_rsETH_26SEP2024
          underly: '0x30c98c0139B62290E26aC2a2158AC341Dcaf1333',
          market: '0xed99fc8bdb8e9e7b8240f62f69609a125a0fbf14',
          duration: 1800,
        },
      ],
    },
    {
      pendlePtOracle: '0x9a9fa8338dd5e5b2188006f1cd2ef26d921650c2',
      expire: Date.UTC(2024, 11, 26),
      assets: [
        {
          // PT_weETH_26DEC2024
          underly: '0xE2B2D203577c7cb3D043E89cCf90b5E24d19b66f',
          market: '0x6b92feb89ed16aa971b096e247fe234db4aaa262',
          duration: 1800,
        },
        {
          // PT_rsETH_26DEC2024
          underly: '0x355ec27c9d4530dE01A103FA27F884a2F3dA65ef',
          market: '0xcb471665bf23b2ac6196d84d947490fd5571215f',
          duration: 1800,
        },
      ],
    },
  ],
  1: [
    {
      pendlePtOracle: '0x9a9fa8338dd5e5b2188006f1cd2ef26d921650c2',
      expire: Date.UTC(2024, 8, 26),
      assets: [
        {
          // PT_pufETH_26SEP2024
          underly: '0xd4e75971eaf78a8d93d96df530f1fff5f9f53288',
          market: '0xa54fc268101c8b97de19ef3141d34751a11996b2',
          duration: 1320,
        },
        {
          // PT_rsETH_26SEP2024
          underly: '0x7bAf258049cc8B9A78097723dc19a8b103D4098F',
          market: '0x6b4740722e46048874d84306b2877600abcea3ae',
          duration: 1320,
        },
        {
          // PT_weETH_26SEP2024
          underly: '0x1c085195437738d73d75dc64bc5a3e098b7f93b1',
          market: '0xc8edd52d0502aa8b4d5c77361d4b3d300e8fc81c',
          duration: 1800,
        },
        {
          // PT_sUSDe_26SEP2024
          underly: '0x6c9f097e044506712B58EAC670c9a5fd4BCceF13',
          market: '0xd1d7d99764f8a52aff007b7831cc02748b2013b5',
          duration: 1320,
        },
      ],
    },
    {
      pendlePtOracle: '0x9a9fa8338dd5e5b2188006f1cd2ef26d921650c2',
      expire: Date.UTC(2024, 11, 26),
      assets: [
        {
          // PT_pufETH_26DEC2024
          underly: '0xF6fd7Ceb095BfD54130359Cc9366a1493944213A',
          market: '0x676106576004ef54b4bd39ce8d2b34069f86eb8f',
          duration: 1320,
        },
        {
          // PT_rsETH_26DEC2024
          underly: '0xb07b9fdd62dc478e521e8bde3630a777725b0eb4',
          market: '0x84a50177a84dad50fdbf665dfbfb39914b52dff2',
          duration: 1320,
        },
        {
          // PT_weETH_26DEC2024
          underly: '0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d',
          market: '0x7d372819240d14fb477f17b964f95f33beb4c704',
          duration: 1800,
        },
      ],
    },
  ],
}

const state = {
  ptApys: {},
}

const getters = {}

const mutations = {
  setPtApys(state, apys) {
    state.ptApys = apys
  },
}

const actions = {
  async getPtToSyRates({ rootState, commit }) {
    return
    const start = Date.now()
    const { chainId, multiProvider } = rootState.wallet
    const configs = CONFIG[chainId]
    if (configs) {
      const apys = {}
      for (const config of configs) {
        const oracle = config.pendlePtOracle
        const assets = config.assets
        const expire = config.expire

        if (expire < Date.now()) {
          continue
        }
        // const rpc = getSupportNetwork().find(net => net.networkId === chainId).readRpc
        const contract = new ethers.Contract(oracle, ABI, multiProvider)

        const callBatch = []
        for (const item of assets) {
          callBatch.push({
            [item.underly.toLowerCase()]: await contract.getPtToAssetRate(item.market, item.duration),
          })
        }

        const resBatch = await Promise.all(callBatch)

        console.log('resBatch', resBatch)
        const daysToExpire = (expire - Date.now()) / (24 * 60 * 60 * 1000)
        // console.log('daysToExpire', daysToExpire)

        for (const item of resBatch) {
          const key = Object.keys(item)[0]
          apys[key] = ((1 / (Number(item[key]) / 1e18) - 1) / daysToExpire) * 365
        }
      }
      console.log('apys', apys)
      commit('setPtApys', apys)
      console.log(`update pt to sy rate elapsed ${Date.now() - start} ms`)
    }
  },
}

export const ptApy = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}
